<template>
  <div class="main-content">
    <h3 class="marginBottom20">销售合伙人协议设置</h3>
    <div style="text-align:right">
      <el-button
        type="primary"
        @click="handleSave"
        style="margin-bottom:20px"
        :loading="loading"
        >{{ disabled ? "编辑" : "保存" }}</el-button
      >
    </div>
    <el-card>
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="content">
          <avue-ueditor
            v-model="form.content"
            :options="options"
            :disabled="disabled"
          ></avue-ueditor>
        </template>
      </avue-form>
    </el-card>
  </div>
</template>

<script>
import { agreementView, agreementUpdate } from "@/api/setting/index";
export default {
  name: "index",
  data() {
    return {
      form: {},
      formOption: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 150,
        column: [
          {
            label: "协议内容",
            prop: "content",
            span: 24,
            row: true,
          },
        ],
      },
      options: {
        action: this.actionUrl,
        customConfig: {}, //wangEditor编辑的配置
        headers: {
          Authorization: this.$store.state.user.Token,
        },
        props: {
          url: "path",
          res: "data",
          name: "path",
        },
      },
      loading: false,
      disabled: true,
    };
  },
  created() {},
  mounted() {
    this.getView();
  },
  methods: {
    async getView() {
      try {
        const { data } = await agreementView();
        // console.log(data)
        this.form = data;
      } catch (e) {
        // console.log('错误',e)
      }
    },
    handleSave() {
      if (this.disabled) {
        this.disabled = false;
        return;
      }
      if (!this.form.content || this.form.content == "<p><br/></p>") {
        this.$message.warning("请输入协议内容");
        return;
      }
      if (this.loading) return;
      this.loading = true;
      agreementUpdate(this.form)
        .then((res) => {
          this.loading = false;
          this.$message.success("保存成功");
          this.disabled = true;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
/deep/.el-descriptions-item .el-descriptions-item__container {
  align-items: center;
}
/deep/.el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
</style>
